import React, { useState } from 'react';
import { FeatureBadge } from './FeatureBadge';
import { SparklesIcon, LeafIcon, SmileIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export function ProductHero() {
  const [activeImage, setActiveImage] = useState(0);
  const productImages = [{
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/3945c7b5-7984-41f1-bb07-6c10d6dc0395.png?v=1764127096',
    alt: 'Faith & Fig Divine Wellness - Front View'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_3c3dli3c3dli3c3d.png?v=1764130731',
    alt: 'Faith & Fig Divine Wellness - Back View'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/b1894142-e473-4b77-ba85-14112e3537a8.png?v=17643226024>',
    alt: 'Faith & Fig Divine Wellness - Product Shot'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/ed6ddea5-d1f5-4263-991e-1812588fe454_d2cc4c6d-3bbd-40a0-9549-bf9c6394e38e.png?v=1764127647',
    alt: 'Faith & Fig Divine Wellness - Detail'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_bpmaapbpmaapbpma.png?v=1764122834',
    alt: 'Faith & Fig Divine Wellness - Back View'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_emoiz4emoiz4emoi.png?v=1764145973',
    alt: 'Faith & Fig Divine Wellness - Product Shot'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_x1opf0x1opf0x1op.png?v=1764143869',
    alt: 'Faith & Fig Divine Wellness - Product Shot'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/a629fde7-2dd6-4138-b3f0-f44b81b3b251.png?v=1764131773',
    alt: 'Faith & Fig Divine Wellness - Product Shot'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/118f759c-b6cd-43ef-a4b0-a910d7ab0536.png?v=1764147417',
    alt: 'Faith & Fig Divine Wellness - Product Shot'
  }, {
    url: 'https://cdn.shopify.com/s/files/1/0637/8940/0115/files/8477ec6d-d4dc-4cf9-96ab-1258e7306868.png?v=1764322601',
    alt: 'Faith & Fig Divine Wellness - Product Shot'
  }];
  const getVisibleThumbnails = () => {
    const totalImages = productImages.length;
    let startIndex = Math.max(0, activeImage - 1);
    if (startIndex + 3 > totalImages) {
      startIndex = totalImages - 3;
    }
    return productImages.slice(startIndex, startIndex + 3).map((img, idx) => ({
      ...img,
      originalIndex: startIndex + idx
    }));
  };
  const handlePrevImage = () => {
    setActiveImage(prev => prev === 0 ? productImages.length - 1 : prev - 1);
  };
  const handleNextImage = () => {
    setActiveImage(prev => prev === productImages.length - 1 ? 0 : prev + 1);
  };
  return <div className="w-full" data-id="element-377">
      {/* LAYOUT STRATEGY:
           Mobile: Use CSS Grid with [72% 26%] ratio.
           - The Image is 'aspect-square', which sets the strict height of the row.
           - The Badges are in the second column with explicit gap spacing.
           
           Desktop: Use Flexbox with smaller gap for tighter spacing.
        */}

      {/* === MOBILE LAYOUT (Grid) === */}
      <div className="lg:hidden w-full grid grid-cols-[72%_26%] gap-2" data-id="element-378">
        {/* Column 1: Image (Driver of Height) */}
        <div className="relative aspect-square w-full" data-id="element-379">
          {/* Brain & Mood Badge */}
          <div className="absolute -top-2 left-2 z-20" data-id="element-380">
            <span className="bg-[#c4d4c0] text-[#2d4a3a] text-[9px] font-bold px-2 py-1 rounded uppercase tracking-wide shadow-lg" data-id="element-381">
              Brain & Mood
            </span>
          </div>

          {/* 90% Badge */}
          <div className="absolute -top-3 -right-3 bg-[#2d4a3a] text-white rounded-full w-14 h-14 flex flex-col items-center justify-center shadow-2xl z-20" data-id="element-382">
            <div className="text-lg font-bold text-[#d4af37]" data-id="element-383">90%</div>
            <div className="text-[6px] text-center leading-tight px-1 mt-0.5 uppercase" data-id="element-384">
              Feel the
              <br data-id="element-385" />
              benefits
            </div>
          </div>

          {/* Main Image */}
          <div className="w-full h-full bg-white rounded-2xl overflow-hidden shadow-lg relative z-10" data-id="element-386">
            <img src={productImages[activeImage].url} alt={productImages[activeImage].alt} className="w-full h-full object-contain p-3" data-id="element-387" />
          </div>
        </div>

        {/* Column 2: Badges (Follower of Height) - Increased spacing on mobile */}
        <div className="flex flex-col justify-start gap-5 h-full py-1" data-id="element-388">
          {/* We use overflow-hidden on the badge wrappers to ensure that if the content
              is slightly too big, it cuts off rather than breaking the grid alignment.
              */}
          <div className="w-full overflow-hidden flex justify-center" data-id="element-389">
            <FeatureBadge icon={<SparklesIcon className="w-3 h-3" data-id="element-391" />} label="Clinically-Studied Formula" compact data-id="element-390" />
          </div>
          <div className="w-full overflow-hidden flex justify-center" data-id="element-392">
            <FeatureBadge icon={<LeafIcon className="w-3 h-3" data-id="element-394" />} label="
Proven Clinical Dosage" value="30mg" compact data-id="element-393" />
          </div>
          <div className="w-full overflow-hidden flex justify-center" data-id="element-395">
            <FeatureBadge icon={<SmileIcon className="w-3 h-3" data-id="element-397" />} label="Stimulant-Free
No jitters. No crashes." compact data-id="element-396" />
          </div>
        </div>
      </div>

      {/* === DESKTOP LAYOUT (Flex) - Reduced spacing on desktop === */}
      <div className="hidden lg:flex flex-row items-stretch gap-6" data-id="element-398">
        {/* Left Column: Image */}
        <div className="flex-1 relative" data-id="element-399">
          <div className="absolute -top-3 left-4 z-20" data-id="element-400">
            <span className="bg-[#c4d4c0] text-[#2d4a3a] text-xs font-bold px-3 py-1.5 rounded uppercase tracking-wide shadow-lg" data-id="element-401">
              CALM + FOCUS + PRESENCE
            </span>
          </div>
          <div className="absolute -top-4 -right-4 bg-[#2d4a3a] text-white rounded-full w-24 h-24 flex flex-col items-center justify-center shadow-2xl z-20" data-id="element-402">
            <div className="text-3xl font-bold text-[#d4af37]" data-id="element-403">90%</div>
            <div className="text-[9px] text-center leading-tight px-2 mt-1 uppercase" data-id="element-404">
              Feel the
              <br data-id="element-405" />
              benefits
            </div>
          </div>
          <div className="aspect-square bg-white rounded-2xl overflow-hidden shadow-lg h-full relative z-10" data-id="element-406">
            <img src={productImages[activeImage].url} alt={productImages[activeImage].alt} className="w-full h-full object-contain p-8" data-id="element-407" />
          </div>
        </div>

        {/* Right Column: Badges - Tighter spacing with gap-3 */}
        <div className="flex flex-col justify-start gap-3 flex-shrink-0 w-auto py-2" data-id="element-408">
          <FeatureBadge icon={<SparklesIcon className="w-5 h-5" data-id="element-410" />} label="Clinically-Studied Formula" compact data-id="element-409" />
          <FeatureBadge icon={<LeafIcon className="w-5 h-5" data-id="element-412" />} label="
Proven Clinical Dosage" value="30mg" compact data-id="element-411" />
          <FeatureBadge icon={<SmileIcon className="w-5 h-5" data-id="element-414" />} label="Stimulant-Free
No jitters. No crashes." compact data-id="element-413" />
        </div>
      </div>

      {/* THUMBNAILS SECTION */}
      <div className="mt-3 lg:mt-4" data-id="element-415">
        <div className="flex items-center gap-2 lg:gap-3" data-id="element-416">
          <button onClick={handlePrevImage} className="flex-shrink-0 w-8 h-8 lg:w-10 lg:h-10 rounded-full bg-[#496f58] hover:bg-[#3d5a47] text-white flex items-center justify-center transition-all shadow-md" data-id="element-417">
            <ChevronLeftIcon className="w-4 h-4 lg:w-5 lg:h-5" data-id="element-418" />
          </button>

          <div className="flex-1 grid grid-cols-3 gap-2 lg:gap-3" data-id="element-419">
            {getVisibleThumbnails().map(image => <button key={image.originalIndex} onClick={() => setActiveImage(image.originalIndex)} className={`
                  aspect-square bg-white rounded-lg overflow-hidden shadow-md
                  transition-all hover:shadow-lg
                  ${activeImage === image.originalIndex ? 'ring-2 lg:ring-4 ring-[#496f58]' : 'ring-1 ring-gray-200'}
                `} data-id="element-420">
                <img src={image.url} alt={image.alt} className="w-full h-full object-contain p-1 lg:p-2" data-id="element-421" />
              </button>)}
          </div>

          <button onClick={handleNextImage} className="flex-shrink-0 w-8 h-8 lg:w-10 lg:h-10 rounded-full bg-[#496f58] hover:bg-[#3d5a47] text-white flex items-center justify-center transition-all shadow-md" data-id="element-422">
            <ChevronRightIcon className="w-4 h-4 lg:w-5 lg:h-5" data-id="element-423" />
          </button>
        </div>

        <div className="text-center mt-2 text-xs text-gray-500" data-id="element-424">
          {activeImage + 1} / {productImages.length}
        </div>

        {/* TRUST LOGOS */}
        <div className="hidden lg:grid grid-cols-2 gap-6 lg:gap-8 pt-6 lg:pt-8 mt-6 lg:mt-8 border-t border-gray-200" data-id="element-425">
          <div className="text-left" data-id="element-426">
            <div className="font-bold text-xs lg:text-sm mb-1" data-id="element-427">BBC</div>
            <div className="font-serif text-base lg:text-lg font-bold text-gray-900 mb-1 lg:mb-2" data-id="element-428">
              DRAGONS' DEN
            </div>
            <p className="text-[10px] lg:text-xs text-gray-600 italic leading-tight" data-id="element-429">
              "The biblical botanical Christian women are using to quiet the mental chaos"
            </p>
            <p className="text-[9px] lg:text-[10px] text-gray-400 mt-0.5 lg:mt-1" data-id="element-430">
              Sara Davies, Host
            </p>
          </div>
          <div className="text-left" data-id="element-431">
            <div className="font-serif text-xl lg:text-2xl font-bold text-gray-900 mb-1 lg:mb-2" data-id="element-432">
              Forbes
            </div>
            <p className="text-[10px] lg:text-xs text-gray-600 leading-tight" data-id="element-433">
              "The Most Potent & Effective Saffron Supplement for Focus yet.."
            </p>
          </div>
        </div>
      </div>
    </div>;
}